export const createGetCanvas = () => {
    const canvasCache = {};
    return ({ cimDocId, selector, overprint }) => {
        const cacheKey = `${cimDocId}-${JSON.stringify(selector)}-${overprint}`;
        if (!canvasCache[cacheKey]) {
            canvasCache[cacheKey] = document.createElement("canvas");
        }
        return canvasCache[cacheKey];
    };
};
//# sourceMappingURL=getCanvas.js.map